module.exports = __webpack_public_path__ + "_assets/img/download_5.0242c64f.png";